import React, { useState,useRef, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { GoogleMap, useJsApiLoader, Autocomplete } from '@react-google-maps/api';
import { useParams } from "react-router-dom";
import { API_URL } from "..";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import {  useMapbox } from "../GoogleMapsContext";
const EditAffiliates = () => {
  const {id} = useParams();
  const {mapboxgl} = useMapbox();
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [phone,setPhone]= useState("")
  const [selectedPlace, setSelectedPlace] = useState(null);
  const autocompleteRef = useRef(null);
  const [formData,setFormData] = useState({})
  const [showAlertMessage, setshowAlertMessage] = useState({
    status:false,
    message:''
  });
  const [isMounted, setIsMounted] = useState(false);
  const incidentGeocoderRef = useRef(null);
  
  
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
      // Cleanup geocoders when unmounting
      if (incidentGeocoderRef.current) {
        incidentGeocoderRef.current.onRemove();
        incidentGeocoderRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    if (!isMounted || !mapboxgl.accessToken) return;

    // Clear existing containers
    const clearContainer = (id) => {
      const container = document.getElementById(id);
      if (container) container.innerHTML = '';
      return container;
    };

    const incidentContainer = clearContainer('incident-location-container');

    if (!incidentContainer ) return;

    // Initialize geocoders with fresh instances
    incidentGeocoderRef.current = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: formData?.address || 'Enter incident location',
      marker: false,
      
    });

    // Add to DOM
    incidentGeocoderRef.current.addTo(incidentContainer);
    incidentGeocoderRef.current.on('result', (e) => {
      const { place_name, center } = e.result;
      setFormData((prev)=>({
        ...prev,
          address: place_name,
          lat: center[1],
          lng: center[0],
          name: place_name.split(',')[0]
        
      }));
  
    });

    return () => {
      if (incidentGeocoderRef.current) {
        incidentGeocoderRef.current.onRemove();
      }
   
    };
  }, [isMounted]);

  const fetchSingleAffiliate = async()=>{
    // fetch-affiliate/:id
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
    const response = await fetch(`${API_URL}/api/affiliates/fetch-affiliate/${id}`,{
        method:'GET',
        headers:headersList,
    });
    const data = await response.json();
    setFormData(data)
    if(data.services_provided){
        const formatted = data.services_provided.split(',');
        setSelectedOptions(formatted.map((item)=>({value:item,label:item})))

    }
    if(data.address && data.map_location){
        const convert = data.map_location.split(',')
        setSelectedPlace({lat:parseFloat(convert[0]), lng:parseFloat(convert[1]), address: data.address})
    }
    setPhone(data.phone)
}
  useEffect(()=>{
    fetchSingleAffiliate();
},[1])



  const options = [
    { value: 'Light Duty Towing', label: 'Light Duty Towing' },
    { value: 'Medium Duty Towing', label: 'Medium Duty Towing' },
    { value: 'Heavy Duty Towing', label: 'Heavy Duty Towing' },
    { value: 'Flatbed Towing', label: 'Flatbed Towing' },
    { value: 'Motorcycle Towing', label: 'Motorcycle Towing' },
    { value: 'Long-Distance Towing', label: 'Long-Distance Towing' },
    { value: 'Emergency Towing', label: 'Emergency Towing' },
    { value: 'Accident Recovery', label: 'Accident Recovery' },
    { value: 'Winch-Out Services', label: 'Winch-Out Services' },
    { value: 'Roadside Assistance', label: 'Roadside Assistance' },
    { value: 'Fuel Delivery', label: 'Fuel Delivery' },
    { value: 'Lockout Services', label: 'Lockout Services' },
    { value: 'Tire Change Services', label: 'Tire Change Services' },
    { value: 'Jump Start Services', label: 'Jump Start Services' },
    { value: 'Impound Towing', label: 'Impound Towing' },
    { value: 'Specialty Vehicle Towing', label: 'Specialty Vehicle Towing' },
    { value: 'Classic Car Towing', label: 'Classic Car Towing' },
    { value: 'Fleet Services', label: 'Fleet Services' },
    { value: 'Commercial Towing', label: 'Commercial Towing' },
    { value: 'Recreational Vehicle Towing', label: 'Recreational Vehicle Towing' },
    ];

    const formatPhoneNumber = (value) => {
      // Remove all non-digit characters
      const cleaned = value.replace(/\D/g, "");
    
      // Format the number as (XXX) XXX-XXXX
      const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    
      if (!match) return value;
    
      const formatted = [
        match[1] && `(${match[1]}`,
        match[2] && `) ${match[2]}`,
        match[3] && `-${match[3]}`,
      ]
        .filter(Boolean)
        .join("");
    
      return formatted;
    };
    const handleInputChange = (e) => {
      const formattedPhone = formatPhoneNumber(e.target.value);
      setPhone(formattedPhone);
    };


    // fetchSingleAffiliate();

  
  const handleChange = (selected) => {
    setSelectedOptions(selected || []);
  };
  const onFormSubmit = async (event) =>{
    event.preventDefault();
    let headersList = {
      "Accept": "*/*",
      "Content-Type": "application/json"
     }
     
     let bodyContent = JSON.stringify({
      
       "business_name": formData.business_name,
       "email": formData.email,
       "phone": phone,
       "no_of_trucks": formData.no_of_trucks,
       "address": selectedPlace.address,
       "map_location": selectedPlace.lat +','+selectedPlace.lng,
       "working_area" : formData.working_area,
       "services_provided" : selectedOptions.map((e)=>e.value).toString(),
       "description": formData.description,
       
     });
     
     let response = await fetch(`${API_URL}/api/affiliates/update/${formData.id}`, { 
       method: "POST",
       body: bodyContent,
       headers: headersList
     });
     
     let data = await response.json();
     if(response.status == 200){
      setshowAlertMessage({
        message: 'success',
        status:true
      });
     
     }else{
      setshowAlertMessage({
        message: 'error',
        status:true
      });
     }
     
  }
  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      setSelectedPlace({
        name: place.name,
        address: place.formatted_address,
        lat: place.geometry?.location?.lat(),
        lng: place.geometry?.location?.lng(),
      });
    }
  };

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Add Job" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-center">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                <div className="card border">
                  <div className="card-body">
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <form onSubmit={(event)=>onFormSubmit(event)}>
                    

                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Business Name <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          name="business_name"
                          value={formData?.business_name}
                          onChange={(e)=>setFormData((prev)=>({...prev,business_name: e.target.value}))}
                          className="form-control radius-8"
                          id="name"
                          
                          placeholder="Enter Full Name"
                        />
                      </div>

                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email Address
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="form-control radius-8"
                          id="email"
                          value={formData?.email}
                          onChange={(e)=>setFormData((prev)=>({...prev,email: e.target.value}))}
                          placeholder="Enter email address"
                        />
                      </div>
                    
                      <div className="mb-20">
                        <label
                          htmlFor="phone"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Phone <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="tel"
                          name="phone"
                          className="form-control radius-8"
                          id="phone"
                          value={phone}
                          onChange={handleInputChange}
                          placeholder="Enter Phone Number"
                        />
                      </div>
                      <div className="mb-20">
                       
                          
                            <label
                              htmlFor="address"
                              className="form-label fw-semibold text-primary-light text-sm mb-8"
                            >
                              Address
                            </label>
                              <div>
   
                              <div>
   
                  <div 
                id="incident-location-container"
                key={`incident-${isMounted}`} // Force re-creation
                style={{ minHeight: '50px' }}
                />
                <input
                type="hidden"
                name="address"
                value={selectedPlace?.address || ''}
                required
                />


</div>

    
    </div>
                          
                         
                        
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="assigned_to"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          No of Trucks
                          
                        </label>
                        <input
                          type="number"
                          name="no_of_trucks"
                          min={1}
                          className="form-control radius-8"
                          id="no_of_trucks"
                          value={formData?.no_of_trucks}
                          onChange={(e)=>setFormData((prev)=>({...prev,no_of_trucks: e.target.value}))}
                          
                          placeholder="Enter no of trucks"
                        />
                      </div>
                    
                      <div className="mb-20">
                        <label
                          htmlFor="desc"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Working Area
                        </label>
                        <input
                          type="tel"
                          name="working_area"
                          className="form-control radius-8"
                          id="working_area"
                          placeholder="Working Area"
                          value={formData?.working_area}
                          onChange={(e)=>setFormData((prev)=>({...prev,working_area: e.target.value}))}
                        />
                        </div>
                      <div className="mb-20">
                        <label
                          htmlFor="desc"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Service You Provide
                        </label>
                        <Select
                            options={options}
                            isMulti
                            value={selectedOptions}
                            onChange={handleChange}
                            placeholder="Select Options"
                        />

                        <div style={{ marginTop: "10px" }}>
                            <strong>Selected Options:</strong>{" "}
                            {selectedOptions.map((option) => option.label).join(", ")}
                        </div>
                         
                        </div>
                      <div className="mb-20">
                        <label
                          htmlFor="desc"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Description
                        </label>
                        <textarea
                           value={formData?.description}
                           onChange={(e)=>setFormData((prev)=>({...prev,description: e.target.value}))}
                          className="form-control radius-8"
                          id="desc"
                          placeholder="Write description..."
                          name="description"
                        />
                      </div>
                      {
                      showAlertMessage.status === true?
                    <div
                        className={
                          showAlertMessage.message == 'error' ?
                          "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10":
                          "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                    >
                        {showAlertMessage.message == 'error' ? "Error while adding updating affiliates" : "Affiliate Is updated successfully"}
                        <button type="button" onClick={()=>setshowAlertMessage(!showAlertMessage)} className="remove-button text-secondary-600 text-xxl line-height-1">
                            {" "}
                            <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                    </div>:null
                    }
                      <div className="d-flex align-items-center justify-content-center gap-3">
                        
                        <button
                          type="submit"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default EditAffiliates;
